import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { CookieService, UserService } from '@service';

@Injectable()
export class AdminAuthGuard implements CanActivate {
  constructor(
    private userService: UserService,
    private cookieService: CookieService,
  ) {}

  async canActivate(): Promise<boolean> {
    const session = this.cookieService.getDesSession();
    if (!this.userService.user()) {
      await lastValueFrom(this.userService.getUserDetails());
    }
    const isAllowed = !!session && this.userService.user()?.permissions['userAdmin']?.includes('R');
    if (!isAllowed) {
      document.location.href = document.location.origin;
    }

    return isAllowed;
  }
}
